/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { Apqsv1Dependency } from '../models/Apqsv1Dependency';
import { Apqsv1Miscellanea } from '../models/Apqsv1Miscellanea';
import { Apqsv1SystemStat } from '../models/Apqsv1SystemStat';
import { HttpFile } from '../http/http';

export class Apqsv1Checks {
    'systemStat'?: Apqsv1SystemStat;
    'dependencies'?: Array<Apqsv1Dependency>;
    'miscellaneous'?: Array<Apqsv1Miscellanea>;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "systemStat",
            "baseName": "systemStat",
            "type": "Apqsv1SystemStat",
            "format": ""
        },
        {
            "name": "dependencies",
            "baseName": "dependencies",
            "type": "Array<Apqsv1Dependency>",
            "format": ""
        },
        {
            "name": "miscellaneous",
            "baseName": "miscellaneous",
            "type": "Array<Apqsv1Miscellanea>",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return Apqsv1Checks.attributeTypeMap;
    }

    public constructor() {
    }
}

